import React from "react";

export default function withType(type) {
  return Component => props => <Component {...props} type={type} />;
}
